/**
 * PageWrapper: the layout older pages use, now drawn by the design system's Page and PageHeader.
 * New pages should import Page and PageHeader from 'design' directly.
 * width: undefined (1440px), 'narrow' (960px) or 'bleed'.
 */
import { Page, PageHeader } from 'design';

export default function PageWrapper({ children, title, subtitle, action, width }) {
  return (
    <Page width={width}>
      {title || subtitle || action ? <PageHeader title={title} description={subtitle} actions={action} /> : null}
      {children}
    </Page>
  );
}
